import TileWrapper from '../TileWrapper'
import { Link } from 'react-router-dom'
import { useTeam } from 'app/frontend/base/config/context/team'
import dayjs from 'dayjs'
import { Calendar } from 'lucide-react'

import { useOverviewData } from 'app/frontend/base/config/queries'

const RecentEventsTile = () => {
  const { team } = useTeam()
  const { data: overviewData } = useOverviewData(team.id)
  const events = overviewData?.recentEvents || []

  if (events.length === 0) {
    return (
      <TileWrapper>
        <p className='text-muted-foreground'>No recent events.</p>
      </TileWrapper>
    )
  }

  return (
    <TileWrapper>
      <ul className='space-y-3'>
        {events.map((event) => (
          <li key={event.id}>
            <Link
              to={`${team.path}/events/${event.id}`}
              className='flex items-start gap-3 rounded p-2 -m-2 transition-colors'
            >
              <Calendar className='h-5 w-5 text-muted-foreground mt-0.5' />
              <div>
                <p className='font-medium'>{event.title}</p>
                <p className='text-sm text-muted-foreground'>
                  {dayjs(event.date).format('ddd, MMM D')}
                </p>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </TileWrapper>
  )
}

export default RecentEventsTile
